import { pillars } from "@/mocks/gossip";

export default function WhyFree() {
  return (
    <section id="why" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-primary-600">
            <i className="ri-award-line text-sm" />
            吃瓜免费，凭什么
          </p>
          <h2 className="font-heading mt-2 text-2xl font-bold text-foreground-900 md:text-3xl">
            把资源全解锁，当成本分
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            不设墙、不折腾、不玩虚的。我们相信好内容值得被轻松看见，
            所以把“免费畅享”做成了默认状态。
          </p>
        </div>

        <div className="mt-9 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {pillars.map((p) => (
            <div
              key={p.title}
              className="flex flex-col rounded-lg border border-background-200/70 bg-background-100/50 p-5 transition-colors hover:border-accent-300 hover:bg-background-50"
            >
              <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className={`${p.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-900">{p.title}</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">{p.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}